const hu_HU = {
    homepage_title: 'CalendarTask mobil verzió letöltése QR kóddal',
    homepage_slogn: 'CalendarTask mobil verzió',
    homepage_ios_download: 'App Store felülvizsgálat alatt...',
    homepage_download: 'Letöltés',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'CalendarTask mobil verzió letöltése QR kóddal',
    phonedownload_slogan: 'Szinkron PC és tablettel, jegyzetek bárhol',
    phonedownload_send_vip: 'Telepítse az alkalmazást és kapjon VIP tagságot',
    phonedownload_screenshot: 'Képernyőkép',
    phodedownload_macos: 'CalendarTask macOS verzió',
    phodedownload_windows: 'CalendarTask Windows verzió',
    phodedownload_otherbutton: 'Megtekintés',
    phodedownload_about: 'Kapcsolat',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Reklámmentes',
    feature_easy: 'Havi nézet, egyszerű és könnyű',
    feature_reminder: 'Egyéni emlékeztető',
    feature_countdown: 'Visszaszámlálás évforduló',

    vip_task_succ: 'Siker. Töltse le az appot a VIP aktiválásához',
    vip_task_error: 'Átvétel sikertelen',

    group_slogn: 'CalendarTask csapat meghívó',

    tt_title: 'CalendarTask',
    tt_share_1: 'Megosztva Önnel',
    tt_share_2: 'Órarend',
    tt_share_show_1: 'Olvassa be a QR kódot a "CalendarTask" alkalmazással, a PC és mobil megjeleníti',
    tt_share_show_2: 'az órarendet',
    tt_share_scan_1: 'Olvasás',
    tt_share_scan_2: '"CalendarTask" alkalmazással',
    tt_share_succ: 'Szinkronizálás sikeres',

    v2_copyright: 'Kapcsolat service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Minden jog fenntartva.',
    v2_download_appstore: 'Letöltés az App Store-ból',
    v2_download_googleplay: 'Elérhető a Google Play-en',

    v2_main_title: 'CalendarTask Mobil',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobil',
    v2_main_description: 'Keresse <span class="name">CalendarTask</span> az App Store-ban vagy Google Play-en',
    v2_download_ios: 'iOS letöltése',
    v2_download_android: 'Android letöltése',
    v2_download_harmonyos: 'HarmonyOS letöltése',
    v2_sync_status: 'Szinkronizálás kész! 1 feltöltve, 0 letöltve',
    v2_feature_title: 'Több eszköz adatszinkronizálás',
    v2_feature_description: 'Szinkron telefon, tablet és PC között'
};
export default hu_HU;
